import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)
export const FORM_CONFIG = formConfig

export const FaultDeviceFormSchema = z.object({
  deviceFaultyDate: z.string({
    message: "Date is required",
  }),
  deviceFaultyNotes: z.string().max(500, "Notes cannot exceed 500 characters").optional(),
  deviceReturned: z.boolean().optional(),
})

export type FaultDeviceFormData = z.infer<typeof FaultDeviceFormSchema>

export function transformToApiRequest(formData: FaultDeviceFormData, deviceNumber: number) {
  const faultyDate = formData.deviceFaultyDate
    ? Math.floor(new Date(formData.deviceFaultyDate).getTime() / 1000)
    : Math.floor(Date.now() / 1000)

  return {
    device: {
      deviceNumber,
      deviceStatus: formData.deviceReturned ? "returned" : "faulty"
    },
    faultInfo: {
      deviceNumber,
      deviceFaultyDate: faultyDate,
      deviceFaultyNotes: formData.deviceFaultyNotes || "",
      deviceReturned: !!formData.deviceReturned,
    }
  }
}
